// extracted by mini-css-extract-plugin
export default {"tabTitle":"template-language_tabTitle__foio1","removeLanguageBtn":"template-language_removeLanguageBtn__hYIBa","contentTab":"template-language_contentTab__Zlmn4"};